import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Stack, Typography, Grid, Box } from "@mui/material";
import dayjs from "dayjs";
import CalendarIcon from "../../../../Assets/Images/Calendar1.svg";

export default function CalenderStar({
  labelStart = "Start date",
  labelEnd = "End date",
  onChange,
}) {
  const { control, watch, setValue } = useForm({
    defaultValues: {
      startDate: dayjs(),
      endDate: dayjs(),
    },
  });

  const startDate = watch("startDate");
  const endDate = watch("endDate");

  useEffect(() => {
    if (onChange) {
      onChange(
        startDate.format("YYYY/MM/DD"),
        endDate.format("YYYY/MM/DD")
      );
    }
  }, [startDate, endDate, onChange]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>

          {/* START DATE */}
          <Grid item xs={12} sm={6}>
            <Stack spacing={0.5}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "13px", sm: "14px" },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {labelStart} <span style={{ color: "#d32f2f" }}>*</span>
              </Typography>

              <Controller
                name="startDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    views={["year", "month", "day"]}     // ⭐ YEAR → MONTH → DAY
                    openTo="day"
                    value={field.value}
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    onChange={(value) => {
                      field.onChange(value);
                      if (
                        endDate &&
                        value &&
                        endDate.isBefore(value) &&
                        value?.isValid()
                      ) {
                        setValue("endDate", value);
                      }
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src={CalendarIcon}
                          alt="calendar"
                          width={18}
                          height={18}
                          style={{ opacity: 0.6 }}
                        />
                      ),
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        inputProps: { readOnly: true },
                        onKeyDown: (e) => e.preventDefault(),
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            height: { xs: "38px", sm: "40px" },
                            "& fieldset": { borderColor: "#e0e0e0" },
                            "&:hover fieldset": { borderColor: "#bdbdbd" },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                              borderWidth: "1px",
                            },
                          },
                        },
                      },
                    }}
                  />
                )}
              />
            </Stack>
          </Grid>

          {/* END DATE */}
          <Grid item xs={12} sm={6}>
            <Stack spacing={0.5}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "13px", sm: "14px" },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {labelEnd} <span style={{ color: "#d32f2f" }}>*</span>
              </Typography>

              <Controller
                name="endDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    views={["year", "month", "day"]}  
                    openTo="day"
                    value={field.value}
                    minDate={startDate}
                    maxDate={dayjs()}
                    format="DD/MM/YYYY"
                    onChange={(value) => {
                      if (value?.isValid()) field.onChange(value);
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src={CalendarIcon}
                          alt="calendar"
                          width={18}
                          height={18}
                          style={{ opacity: 0.6 }}
                        />
                      ),
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        inputProps: { readOnly: true },
                        onKeyDown: (e) => e.preventDefault(),
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            height: { xs: "38px", sm: "40px" },
                            "& fieldset": { borderColor: "#e0e0e0" },
                            "&:hover fieldset": { borderColor: "#bdbdbd" },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                              borderWidth: "1px",
                            },
                          },
                        },
                      },
                    }}
                  />
                )}
              />
            </Stack>
          </Grid>

        </Grid>
      </Box>
    </LocalizationProvider>
  );
}